import { Controller } from "@hotwired/stimulus"

const supportsCursorFx = () => {
  if (typeof window === "undefined") return false

  const prefersReduced = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches
  if (prefersReduced) return false

  const coarse = window.matchMedia?.("(pointer: coarse)")?.matches
  if (coarse) return false

  const noHover = window.matchMedia?.("(hover: none)")?.matches
  if (noHover) return false

  return true
}

export default class extends Controller {
  connect() {
    if (!supportsCursorFx()) return

    this.pointer = { x: window.innerWidth / 2, y: window.innerHeight / 2 }
    this.dot = { x: this.pointer.x, y: this.pointer.y }
    this.glow = { x: this.pointer.x, y: this.pointer.y }

    this.dotEl = document.createElement("div")
    this.dotEl.className = "nd-cursor-dot"

    this.glowEl = document.createElement("div")
    this.glowEl.className = "nd-cursor-glow"

    document.body.appendChild(this.glowEl)
    document.body.appendChild(this.dotEl)

    this.onMove = (e) => {
      this.pointer.x = e.clientX
      this.pointer.y = e.clientY
      this.dotEl.style.opacity = "1"
      this.glowEl.style.opacity = "1"
    }

    this.onDown = () => {
      this.glowEl.style.transform += " scale(0.92)"
    }

    this.onUp = () => {
      // Reset handled by RAF loop.
    }

    window.addEventListener("pointermove", this.onMove, { passive: true })
    window.addEventListener("pointerdown", this.onDown, { passive: true })
    window.addEventListener("pointerup", this.onUp, { passive: true })

    this.raf = requestAnimationFrame(this.animate)
  }

  disconnect() {
    if (this.raf) cancelAnimationFrame(this.raf)

    if (this.onMove) window.removeEventListener("pointermove", this.onMove)
    if (this.onDown) window.removeEventListener("pointerdown", this.onDown)
    if (this.onUp) window.removeEventListener("pointerup", this.onUp)

    if (this.dotEl?.parentNode) this.dotEl.parentNode.removeChild(this.dotEl)
    if (this.glowEl?.parentNode) this.glowEl.parentNode.removeChild(this.glowEl)
  }

  animate = () => {
    const lerp = (a, b, t) => a + (b - a) * t

    this.dot.x = lerp(this.dot.x, this.pointer.x, 0.55)
    this.dot.y = lerp(this.dot.y, this.pointer.y, 0.55)

    this.glow.x = lerp(this.glow.x, this.pointer.x, 0.12)
    this.glow.y = lerp(this.glow.y, this.pointer.y, 0.12)

    // Center elements on pointer.
    this.dotEl.style.transform = `translate3d(${this.dot.x - 4}px, ${this.dot.y - 4}px, 0)`
    this.glowEl.style.transform = `translate3d(${this.glow.x - 32}px, ${this.glow.y - 32}px, 0)`

    this.raf = requestAnimationFrame(this.animate)
  }
}
